import { queryOptions, useQuery } from '@tanstack/react-query'
import getRefData from '../../services/ruutsApi/refData/getRefData'
import { queryKeys } from './queryKeys'

export const refDataQueryOptions = (key: string | undefined) =>
  queryOptions({
    queryKey: queryKeys.refData(key),
    queryFn: ({ signal }) => getRefData(key as string, { signal }),
    // Reference data is immutable per deploy.
    staleTime: Infinity,
  })

export const useRefData = (key: string | undefined) =>
  useQuery({
    ...refDataQueryOptions(key),
    enabled: !!key,
  })
